<template>
    <v-tooltip :disabled="true" top>
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="displayValue"
                prefix="$"
                v-bind:ref="el(item, 'priceElement')"
                single-line
                dense
                hide-details
                min="0"
                :rules="rules"
                :disabled="disabled"
                :error-messages="errorMessages"
                @blur="isInputActive = false; update(item, previousPrice)"
                @focus="isInputActive = true; previousPrice = displayValue; select"
                :tabindex="item.sequence + 1"
                v-on="on"
                v-on:keyup.enter="nextItem(item)"
                v-on:keyup.up="previousItem(item)"
                v-on:keyup.down="nextItem(item)"
            ></v-text-field>
        </template>
        <span>{{ item.errorMessage }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: ["label", "value", "errorMessages", "disabled", "update", "select", "el", "item", "onMoveNext", "onMovePrevious"],
    data: () => {
        return {
            isInputActive: false,
            previousPrice: 0.00,
            rules: []
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    return this.value.toString()
                } else {
                    return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                }
            },
            set: function(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ""));
                if (isNaN(newValue)) {
                    newValue = 0
                }
                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        nextItem(item) {
            this.onMoveNext(item, 'priceElement');
        },
        previousItem(item) {
            this.onMovePrevious(item, 'priceElement');
        },
        focus(index) {
            if (this.$refs[index]) {
                this.$refs[index].focus();
            }
        },
        blur(index) {
            if (this.$refs[index]) {
                this.$refs[index].blur();
            }
        }
    }
}
</script>

<style>

</style>